import { render, staticRenderFns } from "./CashCertificateBox.vue?vue&type=template&id=ab18364a"
import script from "./CashCertificateBox.vue?vue&type=script&lang=js"
export * from "./CashCertificateBox.vue?vue&type=script&lang=js"
import style0 from "./CashCertificateBox.vue?vue&type=style&index=0&id=ab18364a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports